import { useEffect, useState } from "react";
import { useTheme } from "next-themes";
import { cn } from "@/lib/utils";

/**
 * Original FanJago mark from main: public/favlogo-light.png (light surfaces)
 * and public/favlogo-dark.png (dark surfaces).
 * The logo must not change without owner approval.
 */
const LOGO_ON_LIGHT = "/favlogo-light.png";
const LOGO_ON_DARK = "/favlogo-dark.png";

type AppLogoProps = {
  /** Kept so existing call sites compile. Both variants render the original mark. */
  variant?: "mark" | "wordmark";
  /** Mark height in pixels. */
  size?: number;
  className?: string;
  title?: string;
  /** Which surface the mark sits on. "auto" follows the active theme. */
  surface?: "auto" | "light" | "dark";
};

export function AppLogo({
  size = 28,
  className,
  title = "FanJago",
  surface = "auto",
}: AppLogoProps) {
  const { theme, systemTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const resolvedTheme = theme === "system" ? systemTheme : theme;
  const onDark = surface === "dark" || (surface === "auto" && resolvedTheme === "dark");
  const src = onDark ? LOGO_ON_DARK : LOGO_ON_LIGHT;

  if (!mounted && surface === "auto") {
    return <span className="inline-block shrink-0" style={{ width: size, height: size }} aria-hidden />;
  }

  return (
    <img
      src={src}
      alt={title}
      width={size}
      height={size}
      className={cn("shrink-0 object-contain", className)}
    />
  );
}
